<script setup lang="ts">
const cssHref = useState<string | null>("site-css", () => null);
useHead(() => ({
  link: cssHref.value
    ? [{ rel: "stylesheet", href: cssHref.value, tagPriority: 999 }]
    : [],
}));
</script>

<template>
  <div class="h-full min-h-0">
    <nuxt-loading-indicator />
    <slot />
  </div>
</template>
